var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.04 12.6218C23.04 11.8063 22.9668 11.0223 22.8309 10.2695H12V14.7179H18.1891C17.9225 16.1554 17.1123 17.3734 15.8943 18.1888V21.0743H19.6109C21.7855 19.0723 23.04 16.1241 23.04 12.6218Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23.858C15.105 23.858 17.7081 22.8282 19.6109 21.0718L15.8943 18.1864C14.8645 18.8764 13.5472 19.2841 12 19.2841C9.00474 19.2841 6.46951 17.2612 5.56519 14.543H1.72314V17.5225C3.61542 21.2809 7.50451 23.858 12 23.858Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.56523 14.5449C5.33523 13.8549 5.20455 13.1178 5.20455 12.3599C5.20455 11.6019 5.33523 10.8649 5.56523 10.1749V7.19531H1.72318C0.944318 8.74781 0.5 10.5042 0.5 12.3599C0.5 14.2155 0.944318 15.9719 1.72318 17.5244L5.56523 14.5449Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.43324C13.6884 5.43324 15.2043 6.01347 16.3961 7.15301L19.6945 3.8546C17.7029 1.99892 15.0997 0.859375 12 0.859375C7.50451 0.859375 3.61542 3.43642 1.72314 7.19483L5.56519 10.1744C6.46951 7.45619 9.00474 5.43324 12 5.43324Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGoogle);
export default __webpack_public_path__ + "static/media/login-google.186477e290dfc19d53f85c28557cb046.svg";
export { ForwardRef as ReactComponent };